import { render, staticRenderFns } from "./SettingsWidget.vue?vue&type=template&id=27db1382&scoped=true"
import script from "./SettingsWidget.vue?vue&type=script&lang=js"
export * from "./SettingsWidget.vue?vue&type=script&lang=js"
import style0 from "./SettingsWidget.vue?vue&type=style&index=0&id=27db1382&prod&lang=scss"
import style1 from "./SettingsWidget.vue?vue&type=style&index=1&id=27db1382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27db1382",
  null
  
)

export default component.exports